import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import moment from 'moment';
import { saveAsset,updateAsset,deleteAsset } from '../../store/actions/assets';
import { fetchAssetsBySuiteId } from '../../store/actions/assets'
import { selectAssets } from '../../store/selectors/assets';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { setSearch, clearSearch } from '../../store/actions/search'
import { clearAssetFormData } from '../../store/actions/assetForm';
import Loader from '../../components/Loader';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import { fetchSuiteCounts } from '../../store/actions/suites';
import AreaAssetsTable from '../../components/AssetsTable/AreaAssetsTable';

class SuiteAssets extends Component {
  componentDidMount() {
    const { suite, onfetchAssetsBySuiteId,clearSearch } = this.props;
    onfetchAssetsBySuiteId(suite.id);
    clearSearch()
  }

  onSaveAsset = async (asset) => {
    let params={}
    if(asset.id){
      params={
        "id": asset.id,
        "Name": asset.item.name,
        "AreaId": asset.areaId,
        "unitId": this.props.suite.id,
        "ItemId": asset.itemId ? asset.itemId : asset.item.id,
        // "SerialNumber":asset.serialNumber ? asset.serialNumber.trim() : '',
        "RoomType":asset.roomType,
        "UserId":this.props.user.id,
        "DateOfPurchase": asset.dateOfPurchase ? new Date(moment(asset.dateOfPurchase).format('l LT')) : null,
        "VendorId": asset && asset.vendorId ? asset.vendorId: null,
        "VendorName": asset && asset.vendorId ? asset.vendorName : ''
      }
      if(!asset.vendorId) {
        delete params.VendorId;
        delete params.VendorName;
      }
     this.props.onUpdateAsset(params)

    }else{
      params = {
        "UnitId": this.props.suite.id,
        "Name": asset.item.name,
        "AreaId": asset.areaId,
        "ItemId": asset.itemId,
        // "SerialNumber": asset.serialNumber ? asset.serialNumber.trim() : '',
        "RoomType": asset.roomType,
        "UserId": this.props.user.id,
        "DateOfPurchase": asset.dateOfPurchase ? new Date(moment(asset.dateOfPurchase).format('l LT')) : new Date(moment(asset.dateOfPurchase).format('l LT')),
        "VendorId": asset && asset.vendorId ? asset.vendorId: null,
        "VendorName": asset && asset.vendorId ? asset.vendorName : '',
        "allRooms":asset.allRooms && asset.allRooms === true ? true : false
      }
      if(!asset.vendorId) {
        delete params.VendorId;
        delete params.VendorName;
      }
    await this.props.onSaveAsset(params)
    this.props.onFetchSuiteCounts(this.props.suite.id,this.props.user.roles[0].role.name);
    //  this.props.clearAssetFormData()
    }


  }

  onDeleteAsset = async (areaId,assetId) => {
    const { onDeleteAsset, onFetchSuiteCounts,suite,user } = this.props;
   await onDeleteAsset(areaId,assetId,null,null,null,user.id);
   onFetchSuiteCounts(suite.id,user.roles[0].role.name);
  }

  render() {
    const { assets, suite, setSearch, loader  } = this.props;
    return (
      loader ? <Loader /> :
       <AreaAssetsTable
        suite={suite}
        history={this.props.history}
        property={this.props.property}
        assets={assets}
        onSaveAsset={this.onSaveAsset}
        onDeleteAsset={this.onDeleteAsset}
        onSearch={e => setSearch({ assets: e.target.value.trim() })}
        introContent={true}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  assets: selectAssets(state),
  user:selectAuthenticatedUser(state),
  loader: selectPRLoader(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onfetchAssetsBySuiteId: fetchAssetsBySuiteId,
  onSaveAsset: saveAsset,
  onUpdateAsset:updateAsset,
  onDeleteAsset:deleteAsset,
  setSearch,
  clearSearch,
  clearAssetFormData,
  onFetchSuiteCounts: fetchSuiteCounts
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SuiteAssets);
